import findIndex from 'lodash/findIndex'

const initialState = {
  data: [],
  filter:[],
  search:'',
  sort:{
    field:'order_edate',
    asc:0
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_ORDERS':
      return {
        ...state,
        data: action.payload
      }
    case 'SORT_ORDERS':
      return {
        ...state,
        sort: action.sort
      }
    case 'FILTER_ORDERS':
      return {
        ...state,
        filter: action.filter
      }
    case 'SEARCH_ORDERS':
      return {
        ...state,
        search: action.search
      }
    case 'EDIT_ORDER':
      const index = findIndex(state.data, { order_id: action.payload.order_id });
      if (index >= 0) {
        return {
          ...state,
          data: [
            ...state.data.slice(0, index),
            action.payload,
            ...state.data.slice(index + 1)
          ]
        }
      }
      return state;
    case 'EDIT_BALANCE':
      const index1 = findIndex(state.data, { order_id: action.id });
      if (index1 >= 0) {
        return {
          ...state,
          data: [
            ...state.data.slice(0, index1),
            {
              ...state.data[index1],
              p1_srvcsum: state.data[index1].p1_srvcsum + action.difS,
              p1_balance: state.data[index1].p1_balance + action.difB1,
              p2_balance: state.data[index1].p2_balance + action.difB2
              
            },
            ...state.data.slice(index1 + 1)
          ]
        }
      }
      return state;
    case 'CREATE_ORDER':
      return {
        ...state,
        data: [
          ...state.data,
          action.payload
        ]
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/orders.js